// src/components/UserSettingsModal.js
import React, { useState, useContext, useEffect } from 'react';
import { ModalContainer, ModalContent, Form, Label, Button, Select, Input } from './StyledComponents';
import { database } from '../firebase/firebaseConfig';
import { ref, set } from 'firebase/database';
import { updateUserProfile } from '../firebase/firebaseUtils';
import { ThemeContext } from '../context/ThemeContext'; // adjust the path as necessary
import BackupManager from './BackupManager';

const UserSettingsModal = ({
  user,
  isOpen,
  onClose,
  onSave,
  settings,
  birthDate,
  onManageArchivedAccounts,
}) => {
  const { theme, updateTheme } = useContext(ThemeContext);
  const [selectedTheme, setSelectedTheme] = useState(theme.title);
  const [totalLineColor, setTotalLineColor] = useState('#000000');
  const [showTotalLine, setShowTotalLine] = useState(true);
  const [birthDateValue, setBirthDateValue] = useState('');
  const [transactionsPageSize, setTransactionsPageSize] = useState(30);

  useEffect(() => {
    if (settings) {
      setSelectedTheme(settings.theme || theme.title);
      setTotalLineColor(settings.totalLineColor || '#000000');
      setShowTotalLine(settings.showTotalLine !== false);
      setTransactionsPageSize(settings.transactionsPageSize || 30);
    }
    if (birthDate) {
      setBirthDateValue(birthDate);
    }
  }, [settings, theme.title, birthDate]);

  const saveSettings = async () => {
    if (user && user.uid) {
      const settingsRef = ref(database, `users/${user.uid}/settings`);
      const newSettings = {
        ...settings,
        theme: selectedTheme,
        totalLineColor,
        showTotalLine,
        transactionsPageSize: parseInt(transactionsPageSize, 10) || 30,
      };
      try {
        await set(settingsRef, newSettings);
        await updateUserProfile(user.uid, { birthDate: birthDateValue });
        updateTheme(selectedTheme); // Update theme using context
        onSave(newSettings, birthDateValue); // update parent state
        onClose(); // Close the modal after saving
      } catch (error) {
        console.error("Error saving settings: ", error);
      }
    } else {
      console.error("User not defined or user ID (uid) missing");
    }
  };

  return isOpen ? (
    <ModalContainer>
      <ModalContent>
        <Form>
          <Label>Theme:</Label>
          <Select value={selectedTheme} onChange={(e) => setSelectedTheme(e.target.value)}>
            <option value="light">Light</option>
            <option value="dark">Dark</option>
          </Select>
          <Label>Birth Date:</Label>
          <Input type="date" value={birthDateValue} onChange={(e) => setBirthDateValue(e.target.value)} />
          <Label>Total Line Colour:</Label>
          <Input type="color" value={totalLineColor} onChange={(e) => setTotalLineColor(e.target.value)} />
          <Label>
            <input type="checkbox" checked={showTotalLine} onChange={(e) => setShowTotalLine(e.target.checked)} />
            Show Total Line
          </Label>
          <Label>Transactions Page Size:</Label>
          <Input type="number" value={transactionsPageSize} onChange={e => setTransactionsPageSize(e.target.value)} />
          {onManageArchivedAccounts && (
            <Button
              type="button"
              onClick={() => onManageArchivedAccounts()}
            >
              Manage Archived Accounts
            </Button>
          )}
          <h3 style={{ marginTop: '20px' }}>Backups & Simulation</h3>
          <p>
            Create manual snapshots or restore previous automatic backups. Restoring will overwrite current data.
          </p>
          <BackupManager userId={user?.uid} />
          <Button onClick={saveSettings}>Save Settings</Button>
          <Button onClick={onClose}>Close</Button>
        </Form>
      </ModalContent>
    </ModalContainer>
  ) : null;
};

export default UserSettingsModal;
